import faker from 'faker';

export function signupStepConfig({ country, currentDate, onboardingType }) {
  function getEmail() {
    const firstName = faker.name.firstName();
    const lastName = faker.name.lastName();
    const label = Date.now();
    const suffix = ['MANAGED_KYC', 'MANAGED_SME_KYC'].includes(onboardingType)
      ? '+fakepreassessmentapproved'
      : '';

    return `${firstName}.${lastName}+${label}${suffix}@example.com`;
  }

  const email = getEmail();
  const signup = {
    country,
    email,
    confirmationEmail: email,
    merchantId: 'K7654321',
    platform: 'magento',
    createdAt: currentDate,
    pricePlan: 'DEFAULT',
  };
  return {
    signup: {
      value: signup,
      method: 'spreadProperty',
      path: null,
    },
  };
}
